import Variable from "./Variable";

export default Variable;
